import SelectBestAnswerItem from './SelectBestAnswerItem';

export const components = {
  SelectBestAnswerItem,
};
